import { Inject, Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { environment } from '../../environments/environment';
/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class Uploader {

  constructor(public http: Http,private transfer: FileTransfer, private file: File) {
    console.log('Hello DataProvider Provider');
  }
 
  deleteFile(name) {
    return this.http.delete(`${environment.apiUrl}/aws/files/${name}`);
  }
 
  //https://stackoverflow.com/questions/46232347/ionic2-s3-image-upload-is-not-working
  uploadFile(url,file ) {

    //AR: THe file transfer object doesn't seem to work with S3, unable to set the correct header value
    // var ftransfer = this.transfer.create();
    //   var config = {
    //         url:url,
    //         httpMethod: 'POST',
    //         chunkedMode: false,
    //         headers: {
    //           "Content-Type":"image/jpg"
    //         }
    //       }

    // return ftransfer.upload(localURI,url,config).then((result) => {
    //             // when finished upload photo. S3 will return a link of image.
    //             // This link is combined from `s3Params.bucket_name + key`
    //             console.log(result)
    //           }, (error) => {
    //             console.log(error);
    //           });


    const headers = new Headers({
      'Content-type' : 'image/jpeg'
    });

    return this.http.put(url,file,{headers:headers});


    //return this.http.post(url,file);
  }


  


}



// WEBPACK FOOTER //
// ./src/providers/data/uploader.ts